<template>
    <div id="wrapper" class="full-background">

        <div class="dis-table">
            <div class="table-cell">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-sm-4">
                            <form action="" class="" @submit.prevent="sendData">
                                <h1 class="form-title text-white">
                                    <label style="color: #FFFFFF">{{i18n('SMS-CODE')}} </label>
                                </h1>
                                <masked-input mask="111111" @keyup="isInvalid = false" autocomplete="off" class="form-control num" :class="{'is-invalid': isInvalid}" v-model="form.otp" id="phone"/>
                                <button class="btn btn-resend" type="button" @click="sendSmsAgain" :disabled="smsTimeOut > 0" style="color: #FFFFFF; font-size: 14px;">
                                    {{smsTimeOut > 0 ? smsTimeOut : 'Отправить смс-код еще раз'}}
                                </button>
                                <button type="button" @click="sendData" :disabled="smsTimeOut > 0 && form.otp.length < 6" class="btn btn-primary btn-next">{{i18n('Pay')}}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>
<script>
    import FormService from "../services/FormService";
    import MaskedInput from 'vue-masked-input';

    export default {
        components: {MaskedInput},
        data() {
            return {
                code: '',
                payment: {},
                sendSmsForm: new FormService({
                    card_number: '',
                    expire_date: '',
                    order_id: '',
                    phone: '',
                }),
                form: new FormService({
                    card_number: '',
                    expire_date: '',
                    order_id: '',
                    phone: '',
                    uniques: '',
                    otp: '',
                }),
                smsTimeOut: 0,
                isInvalid: false,
            }
        },
        methods: {
            sendSmsAgain() {
                if (this.smsTimeOut === 0) {
                    this.sendSmsForm.post('api/payment/validate')
                        .then(res => {
                            this.$store.state.payment = res.data;
                            this.smsTimeOut = 120;
                            this.form.setData(res.data);
                        })
                }
            },
            sendData() {
                this.form.post('api/payment/confirm')
                    .then(res => {
                        if (res.status === 1) {
                            this.$router.push({name: 'web-qr-code'});
                        } else {
                            this.isInvalid = true;
                            let errMessage = res.errors[0].message ? res.errors[0].message : res.msg;
                            Vue.notify({
                                type: 'error',
                                group: 'foo',
                                title: 'Ошибка!!!',
                                text: errMessage
                            });
                            this.$router.back();
                        }
                    })
            },
            decrement() {
                if (this.smsTimeOut > 0) {
                    this.smsTimeOut--;
                }
            }
        },
        created() {
            if (!this.$store.state.order.id) {
                this.$router.push({name: 'web'});
            }
            this.payment = this.$store.state.payment;
            this.form.setData(this.payment);
            this.sendSmsForm.setData(this.payment);
            setInterval(() => {
                this.decrement();
            }, 1000)
        }
    }
</script>
